/* Mykotheke v3 – heroj: set slika za sezonu, s tihim pokretom i izmjenom svakih 7 s.
   Pokret: kratko „sjedanje“ slike pri učitavanju, blagi paralaks pri skrolanju i prelaz na sljedeću sliku.
   Prelazi: „aquarell“ (zadano; nova slika se razlije mekim, nepravilnim rubom iz mjesta gdje su ljudi),
   „licht“ (topli pojas svjetla prođe preko slike i uvede novu) i „fokus“ (prebacivanje oštrine).
   Pristupačnost (WCAG 2.2.2): dugme za pauzu; izmjena stoji dok je pokazivač na tekstu, dok je fokus u heroju,
   dok heroj nije na ekranu i dok je kartica skrivena. Uz smanjeno kretanje nema automatske izmjene ni prelaza.
   Pregled: ?bild=2, ?efekt=aquarell|licht|fokus, ?takt=7000 (ms). */
(() => {
  const hero = document.querySelector("[data-hero]");
  if (!hero) return;
  const media = hero.querySelector("[data-hero-media]");
  const img = media.querySelector(".hero-img");
  const ctrl = hero.querySelector("[data-hero-ctrl]");
  const segBox = hero.querySelector("[data-hero-segs]");
  const pauseBtn = hero.querySelector("[data-hero-pause]");
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const mobile = matchMedia("(max-width: 749px)");
  const q = new URLSearchParams(location.search);

  // set slika dolazi iz sekcije (mk-hero.liquid): s/l = manja/veća slika, posM = kadar na mobitelu,
  // seed = odakle se „aquarell“ razlijeva (ljudi), kao udio širine i visine slike
  const raw = JSON.parse(hero.querySelector("[data-hero-set]").textContent);
  const big = (innerWidth * (devicePixelRatio || 1)) > 1100;
  const set = raw.map((p) => ({ ...p, src: big ? p.l : p.s }));

  // svaka posjeta počinje sljedećom slikom iz seta; ?bild=2 bira sliku za pregled
  const pick = q.get("bild");
  let i = pick ? (+pick - 1) % set.length : (+(localStorage.getItem("mk-hero") || -1) + 1) % set.length;
  if (!pick) localStorage.setItem("mk-hero", i);
  const show = (n) => {
    if (img.currentSrc !== set[n].src) { img.removeAttribute("srcset"); img.src = set[n].src; }
    img.style.setProperty("--pos-m", set[n].posM);
  };
  show(i);

  // paralaks: slika se pri skrolanju pomjera sporije od teksta
  if (!reduce) {
    let ticking = false;
    const onScroll = () => {
      if (ticking) return; ticking = true;
      requestAnimationFrame(() => {
        const y = Math.min(window.scrollY, hero.offsetHeight);
        hero.style.setProperty("--plx", `${(y * 0.18).toFixed(1)}px`);
        ticking = false;
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  if (set.length < 2 || !ctrl) return;

  // ostale slike se učitavaju tek kad je stranica gotova, da prva slika stigne što brže
  const pics = set.map(() => new Image());
  const load = (n) => {
    if (!pics[n].src) pics[n].src = set[n].src;
    return pics[n].decode().catch(() => {}).then(() => pics[n]);
  };
  const idle = window.requestIdleCallback || ((f) => setTimeout(f, 300));
  if (document.readyState === "complete") idle(() => set.forEach((_, n) => load(n)));
  else addEventListener("load", () => idle(() => set.forEach((_, n) => load(n))));

  /* ---------- prelazi ---------- */

  const layer = (tag, cls) => {
    const el = document.createElement(tag);
    el.className = "hero-fx " + cls;
    el.setAttribute("aria-hidden", "true");
    if (tag === "img") el.alt = "";
    media.append(el);
    return el;
  };
  const objPos = (n) => (mobile.matches ? set[n].posM : "50% 50%").split(" ").map((v) => parseFloat(v) / 100);
  const ease = (p) => (p < 0.5 ? 4 * p * p * p : 1 - (-2 * p + 2) ** 3 / 2);

  // vrijednosni šum (value noise) sa stalnim sjemenom: rub akvarela je nepravilan, ali isti pri svakoj posjeti
  const P = new Uint8Array(512);
  {
    const p = [...Array(256).keys()];
    let s = 7;
    for (let k = 255; k > 0; k--) { s = (s * 16807) % 2147483647; const r = s % (k + 1); [p[k], p[r]] = [p[r], p[k]]; }
    for (let k = 0; k < 512; k++) P[k] = p[k & 255];
  }
  const vn = (x, y) => {
    const xi = Math.floor(x), yi = Math.floor(y), xf = x - xi, yf = y - yi;
    const u = xf * xf * (3 - 2 * xf), v = yf * yf * (3 - 2 * yf);
    const h = (a, b) => P[(P[a & 255] + b) & 255] / 255;
    const a = h(xi, yi), b = h(xi + 1, yi), c = h(xi, yi + 1), d = h(xi + 1, yi + 1);
    return a + (b - a) * u + (c - a) * v + (a - b - c + d) * u * v;
  };
  const fbm = (x, y) => (vn(x, y) * 0.57 + vn(x * 2.03 + 17, y * 2.03 + 3) * 0.29 + vn(x * 4.1 + 5, y * 4.1 + 29) * 0.14);
  const easeS = (p) => 0.5 - Math.cos(Math.PI * p) / 2;

  const FX = {
    // licht: topli, mekani pojas svjetla prelazi zdesna nalijevo (prema naslovu) i uvodi novu sliku, kao sunce kroz prozor
    licht(n, im) {
      const o = layer("img", "licht-img"), z = layer("div", "licht");
      o.src = im.src;
      o.style.setProperty("--pos-m", set[n].posM);
      // maska je 3× šira od slike; od 11,5 % do 88,5 % meki rub ulazi s desne strane i izlazi lijevo
      const opt = { duration: 2200, easing: "cubic-bezier(.4,.1,.25,1)", fill: "forwards" };
      o.animate(
        [{ maskPosition: "11.5% 0", webkitMaskPosition: "11.5% 0", transform: "scale(1.03)" }, { maskPosition: "88.5% 0", webkitMaskPosition: "88.5% 0", transform: "scale(1)" }],
        opt
      );
      z.animate(
        [{ backgroundPosition: "11.5% 0", opacity: 0 }, { opacity: 1, offset: 0.15 }, { opacity: 1, offset: 0.7 }, { backgroundPosition: "88.5% 0", opacity: 0 }],
        opt
      );
      return new Promise((done) => setTimeout(() => done([o, z]), opt.duration + 30));
    },

    // aquarell: nova slika se razlije iz mjesta gdje su ljudi, širokim mekim rubom, kao boja u vodi, i usput blago sjedne
    aquarell(n, im) {
      const k = Math.min(devicePixelRatio || 1, 1.5);
      const W = Math.round(img.offsetWidth * k), H = Math.round(img.offsetHeight * k);
      const cv = layer("canvas", "aquarell");
      cv.width = W; cv.height = H;
      const ctx = cv.getContext("2d");
      ctx.imageSmoothingQuality = "high";
      const [px, py] = objPos(n);
      const sc = Math.max(W / im.naturalWidth, H / im.naturalHeight);
      const dw = im.naturalWidth * sc, dh = im.naturalHeight * sc, dx = (W - dw) * px, dy = (H - dh) * py;
      const ax = dx + set[n].seed[0] * dw, ay = dy + set[n].seed[1] * dh;
      const sx = Math.min(0.97, Math.max(0.03, ax / W)), sy = Math.min(0.97, Math.max(0.03, ay / H));

      // polje: udaljenost od sjemena + krupan šum (nepravilan, mekan rub)
      const GW = 200, GH = Math.round((GW * H) / W), N = GW * GH, asp = W / H, field = new Float32Array(N);
      const dmax = Math.max(...[[0, 0], [1, 0], [0, 1], [1, 1]].map(([x, y]) => Math.hypot((x - sx) * asp, y - sy)));
      let lo = 9, hi = -9;
      for (let y = 0; y < GH; y++) for (let x = 0; x < GW; x++) {
        const u = x / (GW - 1), v = y / (GH - 1);
        const f = Math.hypot((u - sx) * asp, v - sy) / dmax + (fbm(u * 2.4 * asp, v * 2.4) - 0.5) * 0.3;
        field[y * GW + x] = f;
        if (f < lo) lo = f;
        if (f > hi) hi = f;
      }
      const mk = document.createElement("canvas");
      mk.width = GW; mk.height = GH;
      const mctx = mk.getContext("2d"), md = mctx.createImageData(GW, GH);
      const DUR = 2600, SOFT = 0.16, t0 = performance.now();
      return new Promise((done) => {
        const frame = (now) => {
          const p = Math.min(1, (now - t0) / DUR), e = easeS(p), t = lo - 0.02 + (hi - lo + SOFT + 0.04) * e;
          for (let j = 0; j < N; j++) {
            const a = (t - field[j]) / SOFT;
            md.data[j * 4 + 3] = a <= 0 ? 0 : a >= 1 ? 255 : 255 * a * a * (3 - 2 * a);
          }
          mctx.putImageData(md, 0, 0);
          const z = 1.05 - 0.05 * e; // nova slika blago „sjedne“ oko mjesta gdje su ljudi
          ctx.globalCompositeOperation = "source-over";
          ctx.clearRect(0, 0, W, H);
          ctx.drawImage(im, ax - (ax - dx) * z, ay - (ay - dy) * z, dw * z, dh * z);
          ctx.globalCompositeOperation = "destination-in";
          ctx.drawImage(mk, 0, 0, W, H);
          if (p < 1) requestAnimationFrame(frame);
          else done([cv]);
        };
        requestAnimationFrame(frame);
      });
    },

    // fokus: trenutna slika ode iz fokusa, sljedeća se izoštri, kao kad fotograf prebaci oštrinu
    fokus(n, im) {
      const o = layer("img", "fokus");
      o.src = im.src;
      o.style.setProperty("--pos-m", set[n].posM);
      const out = img.animate([{ filter: "blur(0px)" }, { filter: "blur(14px)" }], { duration: 700, easing: "ease-in", fill: "forwards" });
      const a = o.animate(
        [{ opacity: 0, filter: "blur(18px)", transform: "scale(1.04)" }, { opacity: 1, filter: "blur(0px)", transform: "scale(1)" }],
        { duration: 1500, delay: 200, easing: "cubic-bezier(.3,.6,.2,1)", fill: "forwards" }
      );
      return a.finished.then(() => [o, out]);
    },
  };
  const effect = FX[q.get("efekt")] ? q.get("efekt") : "aquarell"; // Sead, 2026-10-21

  /* ---------- izmjena, kontrole i zastoj ---------- */

  const TAKT = +q.get("takt") || 7000;
  hero.style.setProperty("--takt", TAKT + "ms");
  if (reduce) hero.classList.add("no-auto");
  ctrl.hidden = false;
  segBox.innerHTML = set.map((_, n) => `<button type="button" class="hero-seg" aria-label="Bild ${n + 1} von ${set.length} zeigen"><i><b></b></i></button>`).join("");
  const segs = [...segBox.children];
  const mark = (run) => segs.forEach((b, n) => {
    b.classList.toggle("on", n === i);
    b.classList.toggle("run", n === i && run);
    if (n === i) b.setAttribute("aria-current", "true"); else b.removeAttribute("aria-current");
  });

  let busy = false;
  const go = async (n, instant) => {
    if (busy || n === i) return;
    busy = true;
    i = n;
    mark(false);
    const im = await load(n);
    const left = reduce || instant ? [] : await FX[effect](n, im);
    show(n);
    await img.decode().catch(() => {});
    requestAnimationFrame(() => left.forEach((x) => (x.cancel ? x.cancel() : x.remove())));
    mark(!reduce);
    busy = false;
  };
  segs.forEach((b, n) => b.addEventListener("click", () => go(n)));
  // vrijeme prikaza je animacija crtice: kad se napuni, dolazi sljedeća slika (pauza zaustavlja i crticu)
  segBox.addEventListener("animationend", (e) => { if (e.animationName === "seg-fill") go((i + 1) % set.length); });

  const setPaused = (on) => {
    hero.classList.toggle("is-paused", on);
    pauseBtn.setAttribute("aria-label", on ? "Bildwechsel fortsetzen" : "Bildwechsel anhalten");
    localStorage.setItem("mk-hero-pause", on ? "1" : "0");
  };
  pauseBtn.addEventListener("click", () => setPaused(!hero.classList.contains("is-paused")));
  setPaused(localStorage.getItem("mk-hero-pause") === "1");

  // zastoj dok kupac čita ili je fokus u heroju (tekst i dugmad ne „bježe“ ispod pogleda)
  const copy = hero.querySelector(".hero-copy");
  copy.addEventListener("pointerenter", () => hero.classList.add("is-held"));
  copy.addEventListener("pointerleave", () => hero.classList.remove("is-held"));
  hero.addEventListener("focusin", () => hero.classList.add("is-held"));
  hero.addEventListener("focusout", (e) => { if (!hero.contains(e.relatedTarget)) hero.classList.remove("is-held"); });
  // zastoj kad heroj nije na ekranu ili je kartica skrivena
  new IntersectionObserver(([e]) => hero.classList.toggle("is-off", e.intersectionRatio < 0.35), { threshold: [0, 0.35, 1] }).observe(hero);
  document.addEventListener("visibilitychange", () => hero.classList.toggle("is-off", document.hidden));

  mark(!reduce);
})();
